module.exports = __webpack_public_path__ + "img/cart_menu.caafd903.svg";